<template>
  <div class="slide zoom" v-parallax-fit="parallax">
    <div class="maze"></div>
    <div class="hand"></div>
  </div>
</template>

<script>
export default {
  name: 'slide14_2',
  data() {
    return {
      parallax: [
        {
          start: 12200,
          end: 12700,
          fromStyle: { transform: 'translateY(-1800px) translateX(800px) rotateZ(30deg)' },
          toStyle: { transform: 'translateY(0px) translateX(0px) rotateZ(0deg)' },
          easing: 'linear'
        },
        {
          start: 15000,
          end: 15500,
          fromStyle: { transform: 'translateY(-1px) translateX(0px) rotateZ(0deg)' },
          toStyle: { transform: 'translateY(-1800px) translateX(800px) rotateZ(30deg)' },
          easing: 'linear'
        },
      ]
    };
  }
}
</script>

<style lang="scss" scoped>
.slide {
    position: fixed;
    transition: 0.5s;
    z-index: 5;
    left: calc(50% - 71px);
    //top: 100px;
    top: calc(50% - 480px);
    @media(max-width: 600px) {
      left: calc(50% - 41px);
      top: calc(50% - 260px);
    }

    .maze {
      position: absolute;
      transform-origin: center;
      background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/14_PaperMaze_2.png');
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      width: 610px;
      height: 600px;
      left: 0;
      top: 16px;
      @media(max-width: 600px) {
        width: 293px;
        left: -26px;
        top: calc(50% - 422px);
      }
    }

    .hand {
      position: absolute;
      transform-origin: center;
      background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/14_Hand_2.png');
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      width: 301px;
      height: 1190px;
      left: 251px;
      top: -677px;
      transform: rotateZ(15deg);
      @media(max-width: 600px) {
        left: 21px;
        top: calc(50% - 1110px);
      }
    }
}
</style>
